export default __webpack_public_path__ + "c2b053facd8bac4534eb96101a7cb3ee.png";